import { msg } from '@lingui/core/macro';

export const SHARED_CONSENT_MODAL_HEADER_DELETE = msg`Do you want your personal data to be deleted?`;
export const SHARED_CONSENT_MODAL_MSG_DELETE = msg`If you continue, all your personal data will be permanently deleted. This action cannot be undone. Are you sure you want to proceed?`;
export const SHARED_CONSENT_MODAL_HEADER_INFO = msg`Data deletion request submitted`;
export const SHARED_CONSENT_MODAL_MSG_INFO = msg`Your request to delete data has been successfully submitted. You will receive a confirmation email once the process is complete.`;
export const SHARED_CONSENT_MODAL_REQUEST_ID_LABEL = msg`Request ID`;
export const SHARED_CONSENT_MODAL_SUBMITTED_ON_LABEL = msg`Submitted on`;
export const SHARED_CONSENT_MODAL_CONFIRM = msg`Yes, delete data`;
export const SHARED_CONSENT_MODAL_CANCEL = msg`Cancel`;
export const SHARED_CONSENT_MODAL_CLOSE = msg`Close`;
